import React from 'react';
export function SubscriberEditIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.414 5L19 .586l-5.852 5.852-2.076 5.19 1.3 1.3 5.19-2.076L23.414 5zm-9.619 5.205l1.057-2.643L19 3.414 20.586 5l-4.148 4.148-2.643 1.057z"
  }), React.createElement("path", {
    d: "M10.144 13.644A3.98 3.98 0 018.5 14C6.11 14 4 11.86 4 8.5c0-1.71.489-3.108 1.248-4.039C5.973 3.573 7.028 3 8.5 3c1.473 0 2.527.573 3.252 1.461.116.143.225.296.328.459l1.44-1.44C12.412 1.957 10.709 1 8.5 1 4.364 1 2 4.358 2 8.5c0 3.13 1.547 5.814 3.94 6.937-.219.734-1.01 1.027-1.897 1.356C2.641 17.313 1 17.922 1 20.5v2h15v-2c0-2.578-1.641-3.187-3.043-3.707-.887-.329-1.678-.622-1.897-1.356.196-.092.386-.194.57-.307l-1.486-1.486z"
  }));
}